import type { Styles } from "@chakra-ui/theme-tools";

export const styles: Styles = {
  global: {
    /**
     * popsql's QueryWidget run button ships its own colors that don't follow
     * our theme. These rules force the button onto our button tokens. The
     * semantic-token vars flip with color mode, so this complies with both
     * light and dark themes. `!important` is needed to beat the widget's own
     * utility classes. The `--running` state renders the neutral "Cancel"
     * variant and is left alone.
     */
    ".query-widget__run-button:not(.query-widget__run-button--running)": {
      backgroundColor: "var(--chakra-colors-button-solid) !important",
      color: "var(--chakra-colors-fg-inverted) !important",
      "&:hover": {
        backgroundColor: "var(--chakra-colors-button-emphasized) !important",
      },
      "&.query-widget__run-button--disabled": {
        backgroundColor: "var(--chakra-colors-button-subtle) !important",
        color: "var(--chakra-colors-fg-subtle) !important",
      },
    },
  },
};
